export const trialBalanceColumns = [
  { key: 'accountCode', text: `Account Code`, width: '10%' }, // Account Code
  { key: 'category', text: `Category`, width: '10%' }, // Account Category
  { key: 'parentAccount', text: `Main Account`, width: '15%' }, // Account Category
  { key: 'account', text: `Account`, width: '20%' }, // Account Name
  { key: 'debit', text: `Total Debits`, width: '15%' }, // Debit Total
  { key: 'credit', text: `Total Credits`, width: '15%' }, // Credit Total
  { key: 'balance', text: `Balance`, width: '15%' } // Balance (calculated or difference)
];
